import { type SelectionState } from '../state/types';

export function hasActiveEdit(state: SelectionState): boolean {
  return state.activeEdit !== null;
}
